import { FC } from 'react';

import styles from '@/components/RegistrationForm/styles.module.scss';

type Props = {
	text: string;
};

export const FieldLabel: FC<Props> = ({ text }) => {
	return <span className={styles.label}>{text}</span>;
};
